import { GraphColor, LocalGraphColour } from "../Colors";

import { API_URL as api } from "@/config/env";

export const urls = {
	quotaStatus: `${api}ApprovalQuotaModification/GetScenarioStatus`,
	userCountries: `${api}GetUserCountries?`,
   quotaForApproval: `${api}ApprovalQuotaModification/GetQuotaforApproval?`,
   popupGraph: `${api}ApprovalQuotaModification/GetPopUpGraphData?`,
   scenarioModificationList: 
   `${api}ApprovalQuotaModification/GetScenarioModificationList?`,
   Upload : `${api}Approve/Upload`,
   rejectMultiple: `${api}ApprovalQuotaModification/RejectQuotaMultiple?`,
   approve: `${api}ApprovalQuotaModification/ApproveQuotaMultiple?`,
   approveMulWithComment: `${api}ApprovalQuotaModification/ApproveQuotaMultipleComments?`,
   rejectSingle : `${api}ApprovalQuotaModification/RejectQuotaSingle`,
   approveSingle : `${api}ApprovalQuotaModification/ApproveQuota`,
   approveSingleWithComment : `${api}ApprovalQuotaModification/ApproveQuotaComments`,
   Downloadfile: `${api}Define/DownloadFile?`,
};

export const periods = [
	{ key: 1, value: "Current" },
	{ key: 0, value: "Previous" },
];

export function getRowDepletionModel(row) {
	return (row?.depletionModel ?? row?.DepletionModel ?? "").trim().toLowerCase();
}

/** Column layout from displayed rows: all none → quota only; all biweekly → halves; else weeks 1–5. */
export function getModificationTableLayout(rows) {
	if (!rows?.length) return "weekly";
	const models = rows.map(getRowDepletionModel);
	if (models.every((m) => m === "none")) return "none";
	if (models.every((m) => m === "biweekly")) return "biweekly";
	return "weekly";
}

export function isFourWeekDepletionPeriod(depletionPeriodType) {
	return (depletionPeriodType ?? "").trim().toLowerCase().includes("4-week");
}

/** Per-row: week not used for this depletion model (show blank, not 0). */
export function isInactiveModificationWeekForRow(row, weekNumber) {
	const model = getRowDepletionModel(row);
	if (model === "none") return weekNumber >= 2;
	if (model === "biweekly") return weekNumber >= 3;
	return false;
}

export function formatModificationWeekValue(row, weekNumber, value) {
	if (!row || isInactiveModificationWeekForRow(row, weekNumber)) return "";
	if (value === "" || value == null) return "";
	const num = Number(value);
	if (!Number.isFinite(num)) return "";
	return num.toLocaleString("en-US");
}

/** MUI Data Grid v6: row is sometimes missing on valueFormatter — resolve via api.getRow. */
export function getDataGridRowFromParams(params) {
	if (params == null) return {};
	return params.row ?? params.api?.getRow?.(params.id) ?? {};
}

const MIXED_WEEK_COLUMN_DEFS = [
	{ field: "modification1", headerName: "Week 1", weekNumber: 1, priorField: "priorModification1" },
	{ field: "modification2", headerName: "Week 2", weekNumber: 2, priorField: "priorModification2" },
	{ field: "modification3", headerName: "Week 3", weekNumber: 3, priorField: "priorModification3" },
	{ field: "modification4", headerName: "Week 4", weekNumber: 4, priorField: "priorModification4" },
	{ field: "modification5", headerName: "Week 5", weekNumber: 5, priorField: "priorModification5" },
];

/** Mixed (or all-weekly) layout: Week 1–5 with per-row inactive weeks blank. */
export function getMixedWeeklyModificationColumns(depletionPeriodType, { highlightChanges = false } = {}) {
	const showWeek5 = !isFourWeekDepletionPeriod(depletionPeriodType);
	const weekColumns = MIXED_WEEK_COLUMN_DEFS.filter(
		(col) => col.weekNumber !== 5 || showWeek5
	).map((col) => {
		const column = {
			field: col.field,
			headerName: col.headerName,
			flex: 1,
			valueFormatter: (params) => {
				const row = getDataGridRowFromParams(params);
				const value = params?.value ?? row[col.field];
				return formatModificationWeekValue(row, col.weekNumber, value);
			},
		};
		if (highlightChanges) {
			column.cellClassName = (params) => {
				const row = getDataGridRowFromParams(params);
				if (isInactiveModificationWeekForRow(row, col.weekNumber)) return "";
				if (row[col.field] !== row[col.priorField]) {
					return "red-row";
				}
				return "";
			};
		}
		return column;
	});

	return [
		{ field: "modificationNo", headerName: "Modification No", flex: 1 },
		{ field: "customerName", headerName: "Customer/CG", flex: 1 },
		{ field: "number", headerName: "Customer Number", flex: 1 },
		{ field: "skuName", headerName: "SKU", flex: 1 },
		{ field: "skuNumb", headerName: "SKU Number", flex: 1 },
		{
			field: "depletionModelName",
			headerName: "Depletion Type",
			flex: 1,
			valueGetter: (params) =>
				params.row.depletionModelName ?? params.row.DepletionModelName ?? "",
		},
		...weekColumns,
	];
}

export function getQuotaModificationTableRows(data) {
   const rows = data?.map((item, index) =>{
      return {
         id: index,
         scenarioId: item.scenarioId,
         quotaId: item.quotaId,
         scenarioName: item.scenarioName,
         modificationStatus: item.modificationStatus,
         modifiedQuota: item.modifiedQuota, 
         previousQuota: item.previousQuota,
         differenceInQuota: item.differenceInQuota,
         lastActionDate: item.lastActionDate,
         lastActionBy: item.lastActionBy, 
         geoId: item.geoId,
         canCountryApproverApprove : item.canCountryApproverApprove,
         depletionModelName: item.depletionModelName,
         depletionPeriodType: item.depletionPeriodType,
         depletionPeriodTypeName: item.depletionPeriodTypeName,
         periodType: item.periodType,
      };
   });
   console.log("Approval_QuotaModification_getQuotaModificationTableRows", rows);
   for(let i=0; i< rows.length; i++){
      rows[i] = getApproveStatus(rows[i]);
   }
   return rows;
}
function  getApproveStatus (item){
	let modificationStatus = item.modificationStatus.toLowerCase();
	const logedUser = JSON.parse(localStorage.getItem("data"));
	if (logedUser.isAnalyst == true) {
		item['canApproveReject'] = false;
      item['canEdit'] = false;
	}
	else {
		if (modificationStatus == "approved" || modificationStatus == "rejected" || modificationStatus == "draft") {
		item['canApproveReject'] = false;
      item['canEdit'] = true;
		}
		else {
		if ((logedUser.isAdmin || (logedUser.isHQUser && logedUser.isApprover))) {
			if (modificationStatus == "normal modified" || modificationStatus == "shift modified" || modificationStatus == "locally approved") {
			item['canApproveReject'] = true;
         item['canEdit'] = false;
			}
		}
		else if (!logedUser.isHQUser) {
			// if (modificationStatus == "normal modified" || modificationStatus == "shift modified") {
			// item['canApproveReject'] = true;
         // item['canEdit'] = false;
			// }
			// else if (modificationStatus == "locally approved") {
			// item['canApproveReject'] = false;
         // item['canEdit'] = false;
			// }

         if(item.canCountryApproverApprove === 1){
            item['canApproveReject'] = true;
            item['canEdit'] = false;
         }else{
            item['canApproveReject'] = false;
            item['canEdit'] = false;
         }
		}
		}
	}
	return item;
  }

export function preparePopupGraphData(data) {
  const mon = 19;
   // The api returns last 19 months data for each data source. So first 20 items are 
   // unique months
   const periods = data.slice(0, mon)?.map(item => item.period);
   const seriesData = [];
   const duplicateDataSources = data?.map(item => item.dataSourceName);
   const dataSources = Array.from(new Set(duplicateDataSources)); ;

   let start = 0, end = mon;
   for(let d = 0; d < dataSources.length; ++d) {
      const dataSource = dataSources[d];
      let values = [];
      for(let j = start; j < end; ++j) {
         values.push(data[j].value);
      }
      seriesData.push( { name: dataSource, data: values, } );
      start += mon;
      end += mon;
   }
   const duplicateDSForColor = data.map(item => ({
   dataSourceName: item.dataSourceName,
   datasourceID: item.datasourceID
   }));
   const uniqueSet = new Set(duplicateDSForColor.map(JSON.stringify));
   const dsr = Array.from(uniqueSet).map(JSON.parse);
   const color = [];
   for(let i = 0; i < dsr.length; ++i) {
      if(dsr[i].dataSourceName.toLowerCase().includes('ex-factory')){
         color.push(GraphColor["Ex-Factory"]);
      }else if(dsr[i].dataSourceName.toLowerCase().includes('iqvia - midas')){
         color.push(GraphColor["IQVIA - MIDAS"]);
      }
      else if (dsr[i].dataSourceName.toLowerCase().includes("fin.fc-based")) {
			color.push(GraphColor["Fin.FC-based"]);
		}
		else if (dsr[i].dataSourceName.toLowerCase().includes("sc fc-based")) {
			color.push(GraphColor["SC FC-based"]);
		} 
		else if (dsr[i].dataSourceName.toLowerCase().includes("financial forecast")) {
			color.push(GraphColor["Financial Forecast"]);
		}
		else if (dsr[i].dataSourceName.toLowerCase().includes("sc forecast")) {
			color.push(GraphColor["SC Forecast"]);
		}
      else if (dsr[i].dataSourceName.toLowerCase().includes("ai forecast")) {
			color.push(GraphColor["AI Forecast"]);
		}
      else if(dsr[i].dataSourceName.toLowerCase().includes('quota')){
         color.push(GraphColor.Quota);
      }else if(dsr[i].dataSourceName.toLowerCase().includes('gers')){
         color.push(GraphColor.GERS);
      }else if(dsr[i].dataSourceName.toLowerCase().includes('sit')){
         color.push(GraphColor.SIT);
      }else if(dsr[i].datasourceID > 5 && dsr[i].datasourceID < 50){
         color.push(LocalGraphColour[dsr[i].datasourceID]);
      }else{
         color.push("#16d620");
      }
   }
   
   const graphData = { periods, seriesData, color };
   console.log("Approval_QuotaModification_preparePopupGraphData", graphData);
   return graphData;
}

export function getScenarioModificationListRows(data, scenarioCanApproveReject) {
   if(data !== undefined && data !== null){
      const rows = data?.map((item, index) => {
         return {
            id: index, 
            scenarioId: item.scenarioId, 
            quotaId: item.quotaId, 
            modificationId: item.modificationId, 
            geoId: item.geoId, 
            modificationNo: item.modificationNo, 
            modificationStatus: item.modificationStatus, 
            differenceInQuota: item.differenceInQuota, 
            lastActionDate: item.lastActionDate,
            lastActionBy: item.lastActionBy, 
         };
      });
      for(let i=0; i< rows.length; i++){
         rows[i] = getApproveStatus_ModificationList(rows[i], scenarioCanApproveReject);
      }
      return rows;
   }
   return null;
}
function  getApproveStatus_ModificationList (item, scenarioCanApproveReject){
	let modificationStatus = item.modificationStatus.toLowerCase();
	const logedUser = JSON.parse(localStorage.getItem("data"));
	if (logedUser.isAnalyst == true) {
		item['canApproveReject'] = false;
      //item['canEdit'] = false;
	}
	else {
		if (modificationStatus == "approved" || modificationStatus == "rejected" || modificationStatus == "draft") {
		item['canApproveReject'] = false;
      //item['canEdit'] = true;
		}
		else {
		if (logedUser.isLocalUser && logedUser.isApprover && modificationStatus == "locally approved") {
			item['canApproveReject'] = false;
         //item['canEdit'] = false;
		}
      else{
         item['canApproveReject'] = scenarioCanApproveReject;
      }
		}
	}
	return item;
  }

export function getModificationPriorTableRows(priorData, latestData, displayModified, selectedModificationNumber) {
   let rows = [];
   if(!displayModified) {
      for(let i = 0; i < priorData.length; ++i) {
         const priorItem = priorData[i];
         if(selectedModificationNumber !==undefined && selectedModificationNumber !== null && selectedModificationNumber !== ""){
            if(priorItem.modificationNo === selectedModificationNumber){
               const item = {
                  id: i, 
                  modificationNo: priorItem.modificationNo, 
                  customerName: priorItem.customerName, 
                  number: priorItem.number, 
                  skuName: priorItem.skuName, 
                  skuNumb: priorItem.skuNumb,
                  depletionModelName: priorItem.depletionModelName ?? priorItem.DepletionModelName,
                  depletionModel: priorItem.depletionModel ?? priorItem.DepletionModel,
                  modification1: priorItem.modification1, 
                  modification2: priorItem.modification2, 
                  modification3: priorItem.modification3, 
                  modification4: priorItem.modification4, 
                  modification5: priorItem.modification5,
                  modificationComments : priorItem.modificationComments
               }
               rows.push(item);
            }
         }
         else{
            let length = latestData.length
            let lastModification = latestData[length-1].modificationNo;
            if(priorItem.modificationNo === lastModification){
               const item = {
                  id: i, 
                  modificationNo: priorItem.modificationNo, 
                  customerName: priorItem.customerName, 
                  number: priorItem.number, 
                  skuName: priorItem.skuName, 
                  skuNumb: priorItem.skuNumb,
                  depletionModelName: priorItem.depletionModelName ?? priorItem.DepletionModelName,
                  depletionModel: priorItem.depletionModel ?? priorItem.DepletionModel,
                  modification1: priorItem.modification1, 
                  modification2: priorItem.modification2, 
                  modification3: priorItem.modification3, 
                  modification4: priorItem.modification4, 
                  modification5: priorItem.modification5,
                  modificationComments : priorItem.modificationComments
               }
               rows.push(item);
            }
         }
      }
   }
   else {
      for(let i = 0; i < priorData.length; ++i) {
         const priorItem = priorData[i];
         const latestItem = latestData[i];

         const modified = priorItem.modification1 !== latestItem.modification1 ||
         priorItem.modification2 !== latestItem.modification2 ||
         priorItem.modification3 !== latestItem.modification3 ||
         priorItem.modification4 !== latestItem.modification4 ||
         priorItem.modification5 !== latestItem.modification5 || 
         priorItem.modificationComments !== latestItem.modificationComments;

         if(modified) {
            if(selectedModificationNumber !==undefined && selectedModificationNumber !== null && selectedModificationNumber !== ""){
               if(priorItem.modificationNo === selectedModificationNumber){
                  const item = {
                     id: i, 
                     modificationNo: priorItem.modificationNo, 
                     customerName: priorItem.customerName, 
                     number: priorItem.number, 
                     skuName: priorItem.skuName, 
                     skuNumb: priorItem.skuNumb,
                     depletionModelName: priorItem.depletionModelName ?? priorItem.DepletionModelName,
                     depletionModel: priorItem.depletionModel ?? priorItem.DepletionModel,
                     modification1: priorItem.modification1, 
                     modification2: priorItem.modification2, 
                     modification3: priorItem.modification3, 
                     modification4: priorItem.modification4, 
                     modification5: priorItem.modification5,
                     modificationComments : priorItem.modificationComments
                  }
                  rows.push(item);
               }
            }
            else{
               let length = latestData.length
               let lastModification = priorData[length-1].modificationNo;
               if(priorItem.modificationNo === lastModification){
                  const item = {
                     id: i, 
                     modificationNo: priorItem.modificationNo, 
                     customerName: priorItem.customerName, 
                     number: priorItem.number, 
                     skuName: priorItem.skuName, 
                     skuNumb: priorItem.skuNumb,
                     depletionModelName: priorItem.depletionModelName ?? priorItem.DepletionModelName,
                     depletionModel: priorItem.depletionModel ?? priorItem.DepletionModel,
                     modification1: priorItem.modification1, 
                     modification2: priorItem.modification2, 
                     modification3: priorItem.modification3, 
                     modification4: priorItem.modification4, 
                     modification5: priorItem.modification5,
                     modificationComments : priorItem.modificationComments
                  }
                  rows.push(item);
               }
            }
         }
      }
   }
   console.log("Approval_QuotaModification_getModificationPriorTableRows", rows);
   return rows;
}


export function getModificationLatestTableRows(priorData, latestData, displayModified, selectedModificationNumber) {
   let rows = [];
   if(!displayModified) {
      for(let i = 0; i < priorData.length; ++i) {
         const priorItem = priorData[i];
         const latestItem = latestData[i];
         if(selectedModificationNumber !==undefined && selectedModificationNumber !== null && selectedModificationNumber !== ""){
            if(latestData[i].modificationNo === selectedModificationNumber){
               const item = {
                  id: i, 
                  modificationNo: latestItem.modificationNo, 
                  customerName: latestItem.customerName, 
                  number: latestItem.number, 
                  skuName: latestItem.skuName, 
                  skuNumb: latestItem.skuNumb,
                  depletionModelName: latestItem.depletionModelName ?? latestItem.DepletionModelName,
                  depletionModel: latestItem.depletionModel ?? latestItem.DepletionModel,
                  modification1: latestItem.modification1, 
                  modification2: latestItem.modification2, 
                  modification3: latestItem.modification3, 
                  modification4: latestItem.modification4, 
                  modification5: latestItem.modification5,
                  priorModification1 : priorItem.modification1,
                  priorModification2 : priorItem.modification2,
                  priorModification3 : priorItem.modification3,
                  priorModification4 : priorItem.modification4,
                  priorModification5 : priorItem.modification5,
                  modificationComments : latestItem.modificationComments
               }
               rows.push(item);
            }
         }
         else{
            let length = latestData.length
            let lastModification = latestData[length-1].modificationNo;
            if(latestData[i].modificationNo ===lastModification){
               const item = {
                  id: i, 
                  modificationNo: latestItem.modificationNo, 
                  customerName: latestItem.customerName, 
                  number: latestItem.number, 
                  skuName: latestItem.skuName, 
                  skuNumb: latestItem.skuNumb,
                  depletionModelName: latestItem.depletionModelName ?? latestItem.DepletionModelName,
                  depletionModel: latestItem.depletionModel ?? latestItem.DepletionModel,
                  modification1: latestItem.modification1, 
                  modification2: latestItem.modification2, 
                  modification3: latestItem.modification3, 
                  modification4: latestItem.modification4, 
                  modification5: latestItem.modification5,
                  priorModification1 : priorItem.modification1,
                  priorModification2 : priorItem.modification2,
                  priorModification3 : priorItem.modification3,
                  priorModification4 : priorItem.modification4,
                  priorModification5 : priorItem.modification5,
                  modificationComments : latestItem.modificationComments
               }
               rows.push(item);
            }
         }
      }
   }
   else {
      for(let i = 0; i < priorData.length; ++i) {
         const priorItem = priorData[i];
         const latestItem = latestData[i];

         const modified = priorItem.modification1 !== latestItem.modification1 ||
         priorItem.modification2 !== latestItem.modification2 ||
         priorItem.modification3 !== latestItem.modification3 ||
         priorItem.modification4 !== latestItem.modification4 ||
         priorItem.modification5 !== latestItem.modification5 ||
         priorItem.modificationComments !== latestItem.modificationComments;

         if(modified) {
            if(selectedModificationNumber !==undefined && selectedModificationNumber !== null && selectedModificationNumber !== ""){
               if(latestData[i].modificationNo === selectedModificationNumber){
                  const item = {
                     id: i, 
                     modificationNo: latestItem.modificationNo, 
                     customerName: latestItem.customerName, 
                     number: latestItem.number, 
                     skuName: latestItem.skuName, 
                     skuNumb: latestItem.skuNumb,
                     depletionModelName: latestItem.depletionModelName ?? latestItem.DepletionModelName,
                     depletionModel: latestItem.depletionModel ?? latestItem.DepletionModel,
                     modification1: latestItem.modification1, 
                     modification2: latestItem.modification2, 
                     modification3: latestItem.modification3, 
                     modification4: latestItem.modification4, 
                     modification5: latestItem.modification5,
                     priorModification1 : priorItem.modification1,
                     priorModification2 : priorItem.modification2,
                     priorModification3 : priorItem.modification3,
                     priorModification4 : priorItem.modification4,
                     priorModification5 : priorItem.modification5,
                     modificationComments : latestItem.modificationComments
                  }
                  rows.push(item);
               }
            }else{
               let length = latestData.length
               let lastModification = latestData[length-1].modificationNo;
               if(latestData[i].modificationNo === lastModification){
                  const item = {
                     id: i, 
                     modificationNo: latestItem.modificationNo, 
                     customerName: latestItem.customerName, 
                     number: latestItem.number, 
                     skuName: latestItem.skuName, 
                     skuNumb: latestItem.skuNumb,
                     depletionModelName: latestItem.depletionModelName ?? latestItem.DepletionModelName,
                     depletionModel: latestItem.depletionModel ?? latestItem.DepletionModel,
                     modification1: latestItem.modification1, 
                     modification2: latestItem.modification2, 
                     modification3: latestItem.modification3, 
                     modification4: latestItem.modification4, 
                     modification5: latestItem.modification5,
                     priorModification1 : priorItem.modification1,
                     priorModification2 : priorItem.modification2,
                     priorModification3 : priorItem.modification3,
                     priorModification4 : priorItem.modification4,
                     priorModification5 : priorItem.modification5,
                     modificationComments : latestItem.modificationComments
                  }
                  rows.push(item);
               }
            }
         }
      }
   }
   console.log("Approval_QuotaModification_getModificationLatestTableRows", rows);
   return rows;
}
